import clsx from "clsx";
import styles from "./styles.scss";
import { HeaderVariant } from "./types";
import { getHeaderVariant } from "./utils";

export const Header = () => {
  const { pathname } = location;
  const variant = getHeaderVariant(pathname);
  const isTransparent = variant === HeaderVariant.Transparent;
  const shouldShowBackButton = false;

  return (
    <header
      className={clsx(
        styles.headerWrapper,
        isTransparent && styles.transparent,
      )}
    >
      <span className={styles.pageHeader}>Inbox</span>
      <div className={clsx(isTransparent && styles.headerContentWrapper)}>
        <div
          className={clsx(
            styles.rightBarSection,
            isTransparent && styles.rightBarAbsolute,
            shouldShowBackButton && styles.withBackButton,
          )}
        />
      </div>
    </header>
  );
};
